import React from "react";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import Person2RoundedIcon from "@mui/icons-material/Person2Rounded";
import Plans from "../../components/plans";
// import FAQ from "../../components/faq";
// import GetInTouch from "../../components/getintouch";
import { Box, Typography } from "@mui/material";

const ServicesData = [
  {
    header: "Student Management",
    description: "Efficiently manage student information and academic records.",
    icon: <Person2RoundedIcon sx={{ color: "#60a5fa", fontSize: 40 }} />,
  },
  {
    header: "Parent Communication",
    description:
      "Enhance communication between parents and school administration.",
    icon: <ForumRoundedIcon sx={{ color: "#60a5fa", fontSize: 40 }} />,
  },
  {
    header: "Resource Planning",
    description: "Optimize resource allocation for better school operations.",
    icon: (
      <SettingsSuggestRoundedIcon sx={{ color: "#60a5fa", fontSize: 40 }} />
    ),
  },
];

const Services = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#0C308B",
          color: "white",
          display: "flex",
          flexDirection: "column",
          px: { xs: "1rem", sm: "2rem" },
          pt: { xs: "4rem", sm: "6rem" },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3.75rem" },
            lineHeight: 1.2,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Welcome to Helpsoo Services
        </Typography>

        <Typography
          sx={{
            py: "2rem",
            fontSize: { xs: "1rem", sm: "1.125rem" },
            lineHeight: "1.75rem",
            textAlign: "center",
            maxWidth: "40rem",
            mx: "auto",
          }}
        >
          Explore our comprehensive solutions for seamless school management.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 3,
            mb: 4,
          }}
        >
          {ServicesData.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 2,
                border: "1px solid #93c5fd",
                borderRadius: "0.75rem",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                p: 2,
                minWidth: { xs: "100%", sm: "20rem" },
                flex: { xs: "1 1 100%", sm: "1 1 30%" },
              }}
            >
              {item.icon}
              <Box>
                <Typography sx={{ fontWeight: 600 }}>{item.header}</Typography>
                <Typography sx={{ color: "#dbeafe", fontSize: "0.95rem" }}>
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* <Plans /> */}
      {/* <FAQ /> */}
      {/* <GetInTouch /> */}
    </>
  );
};

export default Services;
